// We would like to use the native fetch by default, and override it only when necessary (e.g. in engine)
let fetch = window.fetch;

export const getFetch = () => fetch;

export const overrideFetch = (newFetch: typeof fetch) => {
  fetch = newFetch;
};
